import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=69cbf98e&"
import script from "./Vote.vue?vue&type=script&lang=ts&"
export * from "./Vote.vue?vue&type=script&lang=ts&"
import style0 from "./Vote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports